import { render, staticRenderFns } from "./product_view.vue?vue&type=template&id=be9adc2a&scoped=true&"
import script from "./product_view.vue?vue&type=script&lang=js&"
export * from "./product_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9adc2a",
  null
  
)

export default component.exports